/** Existing canonical entity-detail template addresses. Other typed pages are previews/variants. */
export const CMS_ACTIVE_TEMPLATES = {
  "template-fbo": "fbo",
  "template-airport": "airport",
  "template-flight_school": "flight_school",
  "template-maintenance": "maintenance",
  "template-services": "services",
  "template-experience": "experience",
} as const;
export function cmsActiveTemplateType(slug: string): string | null {
  return Object.hasOwn(CMS_ACTIVE_TEMPLATES, slug)
    ? CMS_ACTIVE_TEMPLATES[slug as keyof typeof CMS_ACTIVE_TEMPLATES]
    : null;
}

export const CMS_SHARED_IMPACT_HEADER = "X-CMS-Confirm-Shared-Impact";
export function cmsHasSharedImpact(
  kind: "page" | "global",
  id: string,
): boolean {
  return kind === "global" || cmsActiveTemplateType(id) !== null;
}
